import React from 'react';
import styled from '@emotion/styled';

const Header = styled.div`
  height: 135px;
  text-align: center;
  height: 90px;
  background-color: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-family: inherit;
  font-weight: 400;
  @media (max-width: 768px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'flex')};
  }
`;

const HeaderLogo = styled.img`
  max-height: 60px;
  max-width: 100%;
`;

const PartnerHeader = ({
  bgColor,
  title,
  logo,
  isLiveHeader,
  hideOnMobile,
}) => {
  const bgStyle = { backgroundColor: bgColor };

  let content = title;

  if (logo) {
    content = <HeaderLogo src={logo} alt={title} />;
  }

  return (
    <Header hideOnMobile={hideOnMobile && !isLiveHeader} style={bgStyle}>
      {content}
    </Header>
  );
};

export default PartnerHeader;
